module.exports = __webpack_public_path__ + "img/ic_alert.b49e0b44.svg";